import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import {Tooltip} from "@mui/material";
import React from "react";

interface InfoTooltipProps {
    title: string
}

function InfoTooltip({title}: InfoTooltipProps) {
    return (
        <Tooltip
            title={title}
            placement="right"
            componentsProps={{tooltip: {sx: {fontSize: '0.85rem'}}}}
        >
            <InfoOutlinedIcon
                sx={{color: 'info.main', cursor: 'help', ml: 0.5, fontSize: '1.2rem', verticalAlign: 'middle'}}
            />
        </Tooltip>
    );
}

export default InfoTooltip;
